<template>
  <div class="album">
    <img :src="album.displaySmallPhoto" alt="">
    <p class="twoline">{{album.name}}</p>
  </div>
</template>

<script>
export default {
  props: ["album"]
};
</script>

<style scoped>
.item {
  width: 94px;
  height: 146px;
}
img {
  display: block;
  width: 94px;
  height: 94px;
  border-radius:12px;
}
p {
  margin-top: 8px;
  width: 94px;
  height: 34px;
  font-size: 12px;
  color: rgba(36, 67, 82, 1);
  line-height: 17px;
}
.twoline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>